import styled from "styled-components";

const InputIconContainer = styled.div`
  position: relative;
`;

export default InputIconContainer;
